import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41cdcf1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Content", -1))
const _hoisted_3 = { class: "mx-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Descriptions", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Banner", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Badge", -1))
const _hoisted_13 = {
  key: 0,
  class: ""
}
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Colors", -1))
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Media", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_DigitalAssetUpload = _resolveComponent("DigitalAssetUpload")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "headline",
          label: "Headline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.headline,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemLayoutData.headline) = $event)),
              placeholder: "Headline"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "secondaryHeadline",
          label: "Secondary Headline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.secondaryHeadline,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageItemLayoutData.secondaryHeadline) = $event)),
              placeholder: "Secondary Headline"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_draggable, {
          class: "p-0 m-0",
          handle: ".drag",
          modelValue: _ctx.signageItemLayoutData.descriptions,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signageItemLayoutData.descriptions) = $event)),
          tag: "ul",
          "item-key": "id"
        }, {
          item: _withCtx(({ element, index }) => [
            _createElementVNode("li", {
              class: _normalizeClass(["d-flex align-items-center", { 'mb-2' : index < _ctx.signageItemLayoutData.descriptions.length }])
            }, [
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "Reorder",
                placement: "bottom",
                "hide-after": 0,
                "show-after": 500
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    class: "me-2 drag",
                    icon: _ctx.mdiDragHorizontalVariant
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_input, {
                class: "flex-grow-1 m-0 mx-2",
                modelValue: _ctx.signageItemLayoutData.descriptions[index],
                "onUpdate:modelValue": ($event: any) => ((_ctx.signageItemLayoutData.descriptions[index]) = $event),
                placeholder: "Name"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "Duplicate",
                placement: "bottom",
                "hide-after": 0,
                "show-after": 500
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "dt-icon-button",
                    onClick: ($event: any) => (_ctx.signageItemLayoutData.descriptions.splice(index, 0 , element)),
                    type: "button"
                  }, [
                    _createVNode(_component_Icon, { icon: _ctx.mdiContentDuplicate }, null, 8, ["icon"])
                  ], 8, _hoisted_5)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "Delete",
                placement: "bottom",
                "hide-after": 0,
                "show-after": 500
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "dt-icon-button",
                    onClick: ($event: any) => (_ctx.signageItemLayoutData.descriptions.splice(index, 1)),
                    type: "button"
                  }, [
                    _createVNode(_component_Icon, { icon: _ctx.mdiClose }, null, 8, ["icon"])
                  ], 8, _hoisted_6)
                ]),
                _: 2
              }, 1024)
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            class: "mt-2",
            type: "primary",
            plain: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signageItemLayoutData.descriptions.push('')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Add a Description")
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_divider),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.signageItemLayoutData.showBanner,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signageItemLayoutData.showBanner) = $event))
        }, null, 8, ["modelValue"]),
        (_ctx.signageItemLayoutData.showBanner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_el_form_item, {
                class: "mt-4 col-lg-6",
                prop: "banner",
                label: "Banner Text"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.signageItemLayoutData.banner,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.signageItemLayoutData.banner) = $event)),
                    placeholder: "Banner Text"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_form_item, {
                  class: "me-4",
                  prop: "bannerBackgroundColor",
                  label: "Banner Background Color"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_color_picker, {
                      class: "mt-1",
                      modelValue: _ctx.signageItemLayoutData.bannerColor,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.signageItemLayoutData.bannerColor) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  prop: "bannerFontColor",
                  label: "Banner Font Color"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_color_picker, {
                      class: "mt-1",
                      modelValue: _ctx.signageItemLayoutData.bannerFontColor,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.signageItemLayoutData.bannerFontColor) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_divider, {
        class: _normalizeClass({ 'mt-0' : _ctx.signageItemLayoutData.showBanner })
      }, null, 8, ["class"]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.signageItemLayoutData.showBadge,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.signageItemLayoutData.showBadge) = $event))
        }, null, 8, ["modelValue"]),
        (_ctx.signageItemLayoutData.showBadge)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_el_form_item, {
                class: "mt-4 col-lg-6",
                prop: "badge",
                label: "Badge Text"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.signageItemLayoutData.badge,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.signageItemLayoutData.badge) = $event)),
                    placeholder: "Badge Text"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_form_item, {
                  class: "me-4",
                  prop: "badgeBackgroundColor",
                  label: "Badge Background Color"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_color_picker, {
                      class: "mt-1",
                      modelValue: _ctx.signageItemLayoutData.badgeColor,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.signageItemLayoutData.badgeColor) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  prop: "badgeFontColor",
                  label: "Badge Font Color"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_color_picker, {
                      class: "mt-1",
                      modelValue: _ctx.signageItemLayoutData.badgeFontColor,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.signageItemLayoutData.badgeFontColor) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_divider, {
        class: _normalizeClass({ 'mt-0' : _ctx.signageItemLayoutData.showBadge })
      }, null, 8, ["class"]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "fontColor",
            label: "Font Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.fontColor,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.signageItemLayoutData.fontColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "backgroundColor1",
            label: "Background Color 1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.backgroundColor1,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.signageItemLayoutData.backgroundColor1) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "backgroundColor2",
            label: "Background Color 2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.backgroundColor2,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.signageItemLayoutData.backgroundColor2) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(_component_el_form_item, { label: "Featured Image" }, {
          default: _withCtx(() => [
            _createVNode(_component_DigitalAssetUpload, {
              allowVideo: "true",
              sizeLimitMB: "300",
              layoutProperty: "asset1",
              layoutType: _ctx.layoutType,
              assetUrl: _ctx.assetUrl[0]
            }, null, 8, ["layoutType", "assetUrl"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Use Company Branding Image" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              class: "mt-1",
              modelValue: _ctx.signageItemLayoutData.useCompanyBrandingImage,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.signageItemLayoutData.useCompanyBrandingImage) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.signageItemLayoutData.useCompanyBrandingImage)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Company Branding Image"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DigitalAssetUpload, {
                  allowVideo: "false",
                  sizeLimitMB: "300",
                  layoutProperty: "asset2",
                  layoutType: _ctx.layoutType,
                  assetUrl: _ctx.assetUrl[1]
                }, null, 8, ["layoutType", "assetUrl"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}